/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

//LDS Customer Order History refers to Users Order History

import { Module, Node, Waiting } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

// import { IGroup, IGroupDelivery, IGroups } from '../../common/get-groups';
// import { IOrderInformation } from '../../common/get-order-information';
import { IGroup, IGroupDelivery, IGroups, IOrderInformation, ISalesLine } from '@msdyn365-commerce-modules/order-management';
import { ISalesOrder } from './components/get-sales-order';
import { IHeader, IList, IOrderHistoryViewProps } from './lds-customer-order-history';
//@ts-ignore
import { Primary, Ghost, Secondary } from '@churchofjesuschrist/eden-buttons';
// import { cancelOrderAsync } from '../../actions/DataActionExtension.g';

// @ts-ignore
import { Info, Modal } from '@churchofjesuschrist/eden-alert';

// @ts-ignore
import { ProgressSection } from '@churchofjesuschrist/eden-progress';
import CancelOrderModal from '../../helpers/utilities/cancel-order-modal/CancelOrderModal';
import { cancelOrderAsync } from '../../actions/DataActionExtension.g';

interface GroupDeliveryProps extends IGroupDelivery {
    salesLines?: any;
    resources?: any;
}
interface ListProps extends IList {
    resources?: any;
    context?: any;
    setIsOpen?: any;
    setOrderId?: any;
    setSalesOrderId?: any;
    isOrderCancellationSupported?: boolean;
    allowOrderSyncCancelation?: boolean;
}
interface SalesProps extends ISalesOrder {
    resources?: any;
    context?: any;
    setIsOpen?: any;
    setOrderId?: any;
    isOrderCancellationSupported?: boolean;
    setSalesOrderId?: any;
    allowOrderSyncCancelation?: boolean;
}
interface GroupProps extends IGroup {
    resources?: any;
}
interface GroupsProps extends IGroups {
    resources?: any;
}

export const OrderHistoryOrderInfomation: React.FC<IOrderInformation> = ({
    orderInformationProps,
    salesId,
    receiptId,
    channelName,
    createdDate,
    count,
    amount,
    channelReferenceId
}) => {
    return (
        <Node {...orderInformationProps}>
            {channelName}
            {salesId}
            {receiptId}
            {createdDate}
            {count}
            {amount}
            {/* {channelReferenceId} */}
        </Node>
    );
};

export const OrderHistoryGroupDelivery: React.FC<GroupDeliveryProps> = ({
    deliveryProps,
    heading,
    count,
    processing,
    address,
    trackingInfo,
    salesLines,
    resources
}) => {
    //@ts-ignore
    if (address && address.props) {
        if (salesLines.length === 0) {
            //@ts-ignore
            address.props.resource.shipToLabel = resources.delivereySalesLines;
        }
    }
    return (
        <Node {...deliveryProps}>
            {/* {salesLines && salesLines.length !== 0 && heading} */}
            {/* {salesLines && salesLines.length === 0 && <div className='ms-order-history__sales-status'>{resources.deliveredSalesLines}</div>} */}
            {/* {count} */}
            {/* {processing} */}
            {/* {address} */}
            {/* {trackingInfo} */}
        </Node>
    );
};

export const OrderHistoryGroup: React.FC<GroupProps> = ({ groupProps, delivery, salesLinesProps, salesLines, resources }) => {
    let deliveryLines;
    if (salesLines && salesLines[0]) {
        deliveryLines = salesLines.filter(saleLine => {
            if (saleLine.data.product) {
                //@ts-ignore
                return saleLine.data.product.ExtensionProperties[0].Value?.BooleanValue === false;
            } else {
                return;
            }
        });
    }
    return (
        <Node {...groupProps}>
            {delivery && <OrderHistoryGroupDelivery {...delivery} salesLines={deliveryLines} resources={resources} />}
            {salesLines && (
                <Node {...salesLinesProps}>
                    {salesLines.map((salesLine: ISalesLine) => (
                        <React.Fragment key={salesLine.data.salesLine.LineId}>{salesLine.salesLine}</React.Fragment>
                    ))}
                </Node>
            )}
        </Node>
    );
};

export const OrderHistoryGroups: React.FC<GroupsProps> = ({ groupsProps, groups, resources }) => (
    <Node {...groupsProps}>
        {groups.map((group: IGroup, index: number) => (
            <OrderHistoryGroup key={index} {...group} resources={resources} />
        ))}
    </Node>
);

export const OrderHistoryHeader: React.FC<IHeader> = ({ headerProps, heading, orderCountLabel, extraActions }) => {
    return (
        <Node {...headerProps}>
            {heading}
            {/* {orderCountLabel} */}
            {extraActions}
        </Node>
    );
};

export const OrderHistorySalesOder: React.FC<SalesProps> = ({
    salesOrderProps,
    orderInfomation,
    groups,
    orderDetailsLink,
    expandProductsButton,
    orderHeader,
    resources,
    context,
    setIsOpen,
    setOrderId,
    setSalesOrderId,
    isOrderCancellationSupported,
    allowOrderSyncCancelation
}) => {
    const handleCancelOrder = () => {
        setIsOpen(true);
        // @ts-ignore
        setOrderId(orderInfomation.channelReferenceId.props.children[1].props.children);
        // @ts-ignore
        setSalesOrderId(salesOrderProps.key);
    };
    // let shouldShowCancelOrderButton = false;

    // if (orderHeader && orderHeader.SalesId && orderHeader.SalesId.toLowerCase().includes('so-')) {
    //     shouldShowCancelOrderButton = true;
    // }
    // console.log('shouldShowCancelOrderButton', shouldShowCancelOrderButton);

    return (
        <Node {...salesOrderProps}>
            {orderInfomation && <OrderHistoryOrderInfomation {...orderInfomation} />}
            {groups && <OrderHistoryGroups {...groups} resources={resources} />}
            {expandProductsButton}
            {orderDetailsLink}
            {/* @ts-ignore */}
            {groups &&
                groups.groups &&
                groups.groups.length > 0 &&
                groups.groups[0].data.salesStatus.toLowerCase() === 'processing' &&
                isOrderCancellationSupported && (
                    // shouldShowCancelOrderButton && (
                    <Ghost
                        // onClick={() => handleCancelOrder()}
                        onClick={() => handleCancelOrder()}
                        style={{ marginTop: '20px', marginLeft: '10px' }}
                    >
                        {resources.cancelOrderButton}
                    </Ghost>
                )}
        </Node>
    );
};

export const OrderHistoryList: React.FC<ListProps> = ({
    listProps,
    salesOrders,
    resources,
    context,
    setIsOpen,
    setOrderId,
    setSalesOrderId,
    isOrderCancellationSupported,
    allowOrderSyncCancelation
}) => (
    <Node {...listProps}>
        {salesOrders &&
            salesOrders.map((salesOrder: ISalesOrder, index: number) => (
                <OrderHistorySalesOder
                    key={index}
                    {...salesOrder}
                    resources={resources}
                    context={context}
                    setIsOpen={setIsOpen}
                    setOrderId={setOrderId}
                    setSalesOrderId={setSalesOrderId}
                    isOrderCancellationSupported={isOrderCancellationSupported}
                    allowOrderSyncCancelation={allowOrderSyncCancelation}
                />
            ))}
    </Node>
);

export const OrderHistoryView: React.FC<IOrderHistoryViewProps> = props => {
    const {
        orderHistoryProps,
        // header,
        alert,
        // loading,
        emptyMessage,
        // backToShoppingLink,
        list,
        table,
        // moreButton,
        resources,
        getOrderHistory
    } = props;

    const [shouldShowMore, setShouldShowMore] = React.useState(true);
    const [skip, setSkip] = React.useState(5);
    const [loading, setLoading] = React.useState(false);
    const [isOpen, setIsOpen] = React.useState(false);
    const [orderId, setOrderId] = React.useState('');
    const [salesOrderId, setSalesOrderId] = React.useState('');
    const [isLoading, setIsLoading] = React.useState(false);
    const [isOrderCancellationSupported, setIsOrderCancellationSupported] = React.useState(false);
    const [isOrderCancelled, setIsOrderCancelled] = React.useState<boolean | null>(null);
    React.useEffect(() => {
        sessionStorage.setItem('orderHistory', 'true');
    }, []);

    React.useEffect(() => {
        // @ts-ignore
        if (props.data.cart && props.data.cart.result && props.data.cart.result.cart && props.data.cart.result.cart.ExtensionProperties) {
            // @ts-ignore
            const country = props.data.cart.result.cart.ExtensionProperties.filter((property: any) => {
                return property.Key === 'Country';
            });
            if (
                country &&
                country[0] &&
                country[0].Value &&
                country[0].Value.StringValue &&
                // @ts-ignore
                props.config.orderCancellationCountryList &&
                // @ts-ignore
                props.config.orderCancellationCountryList.length > 0
            ) {
                // @ts-ignore
                const isOrderCancellationSupported = props.config.orderCancellationCountryList.includes(country[0].Value.StringValue);
                if (isOrderCancellationSupported) {
                    setIsOrderCancellationSupported(true);
                }
            }
        }
    }, []);

    const handleClick = async () => {
        setLoading(true);
        const res = await getOrderHistory(skip, setShouldShowMore);
        // if (!props.viewState.connectionFailed) {
        setSkip(prevState => (prevState += 5));
        // }

        setLoading(false);

        return res;
    };

    const handleCancelOrder = async () => {
        const ctx = { callerContext: props.context.actionContext };
        // let res: any;
        setIsLoading(true);
        if (orderId) {
            // res = await cancelOrderAsync(ctx, orderId);
            await cancelOrderAsync(ctx, orderId);
        }
        // if (res.Success && res.Success === true) {
        //     setIsLoading(false);
        //     setIsOrderCancelled(true);
        // } else {
        //     setIsLoading(false);
        //     setIsOrderCancelled(false);
        // }
        // setIsLoading(false);
    };

    const handleCloseModal = () => {
        setIsOpen(false);
        setIsOrderCancelled(null);
        setOrderId('');
        setSalesOrderId('');
    };

    return (
        <Module {...orderHistoryProps} style={{ width: '100%', height: '100%', borderTop: '1px solid #000' }}>
            <CancelOrderModal
                isOpen={isOpen}
                isLoading={isLoading}
                onClose={handleCloseModal}
                onConfirm={() => handleCancelOrder()}
                resource={resources}
                isOrderCancelled={isOrderCancelled}
                orderId={orderId}
                salesOrderId={salesOrderId}
                allowOrderSyncCancelation={props.config.allowOrderSyncCancelation || false}
            />
            {loading && (
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                    <Waiting />
                </div>
            )}
            {alert && (
                <>
                    {alert}
                    {/* {backToShoppingLink} */}
                </>
            )}
            {emptyMessage && (
                <>
                    {emptyMessage}
                    {/* {backToShoppingLink} */}
                </>
            )}
            {list && (
                <OrderHistoryList
                    {...list}
                    resources={resources}
                    context={props.context}
                    setIsOpen={setIsOpen}
                    setOrderId={setOrderId}
                    setSalesOrderId={setSalesOrderId}
                    isOrderCancellationSupported={isOrderCancellationSupported}
                    // @ts-ignore
                    allowOrderSyncCancelation={props.config.allowOrderSyncCancelation}
                />
            )}
            {table}
            {shouldShowMore && !emptyMessage && (
                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '10px' }}>
                    <Primary style={{ width: '100%' }} onClick={() => handleClick()}>
                        {resources.moreButtonText}
                    </Primary>
                </div>
            )}
        </Module>
    );
};

export default OrderHistoryView;
